import React from "react"

function CloseIcon() {
  return (
    <svg
      viewBox="0 0 20 20"
      preserveAspectRatio="none"
      width={12}
      fill="transparent"
      stroke="#979797"
      strokeWidth="1.1px"
    >
      <path d="M1,1 L19,19" />
      <path d="M19,1 L1,19" />
    </svg>
  )
}

export default CloseIcon



// WEBPACK FOOTER //
// ./src/components/themed-html-components/CloseIcon.jsx